import { h } from 'preact';
import { useState } from 'preact/hooks';

type Props = {
  onSend: (text: string) => void;
  disabled?: boolean;
  placeholder: string;
  billingLabel?: string;
  billingTone?: 'free' | 'paid' | 'premium';
};

export function ChatInput({ onSend, disabled, placeholder, billingLabel, billingTone = 'paid' }: Props) {
  const [text, setText] = useState('');

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (!text.trim() || disabled) return;
    onSend(text.trim());
    setText('');
  };

  return (
    <form class="chat-input-row" onSubmit={handleSubmit}>
      <div class="chat-input-wrap">
        <input
          type="text"
          class="chat-input"
          value={text}
          onInput={(e) => setText(e.currentTarget.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
        {billingLabel ? (
          <span class={`chat-input-billing ${billingTone}`}>{billingLabel}</span>
        ) : null}
      </div>
      <button type="submit" class="chat-send-btn" disabled={!text.trim() || disabled}>
         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 2L11 13" />
            <path d="M22 2l-7 20-4-9-9-4 20-7z" />
         </svg>
      </button>
    </form>
  );
}
